import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicFormComponent } from './containers/dynamic-form/dynamic-form.component';
import { FormInputComponent } from './components/form-input/form-input.component';
import { DynamicFieldDirective } from './components/dynamic-field/dynamic-field.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FormSelectComponent } from './components/form-select/form-select.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormButtonComponent } from './components/form-button/form-button.component';
import { ButtonModule } from 'primeng/button';
import { FormCalendarComponent } from './components/form-calendar/form-calendar.component';
import { CalendarModule } from 'primeng/calendar';
import { FormCheckboxComponent } from './components/form-checkbox/form-checkbox.component';
import { CheckboxModule } from 'primeng/checkbox';
import { FormTextareaComponent } from './components/form-textarea/form-textarea.component';
import { FormHeaderComponent } from './components/form-header/form-header.component';
import { FormSpinnerComponent } from './components/form-spinner/form-spinner.component';
import { SpinnerModule } from 'primeng/spinner';
import { FormCprComponent } from './components/form-cpr/form-cpr.component';



@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
    CalendarModule,
    CheckboxModule,
    SpinnerModule,
    FormsModule
  ],
  declarations: [
    DynamicFieldDirective,
    DynamicFormComponent,
    FormInputComponent,
    FormSelectComponent,
    FormButtonComponent,
    FormCalendarComponent,
    FormCheckboxComponent,
    FormTextareaComponent,
    FormHeaderComponent,
    FormSpinnerComponent,
    FormCprComponent
  ],
  exports: [DynamicFormComponent],
  entryComponents: [
    FormInputComponent,
    FormSelectComponent,
    FormButtonComponent,
    FormCalendarComponent,
    FormCheckboxComponent,
    FormTextareaComponent,
    FormHeaderComponent,
    FormSpinnerComponent,
    FormCprComponent
  ],
})
export class DynamicFormModule { }
